module.exports = __webpack_public_path__ + "img/saizi2.79b40a01.png";